<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Manage Permissions') }}</h1>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <el-table :data="permissions.data" @sort-change="handleSortChange" fit highlight-current-row>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="60" fixed></el-table-column>
                                    <el-table-column :label="$t('Actions')" colspan="2" width="100" fixed>
                                        <template slot-scope="scope">
                                            <ul class="act-list">
                                                <li v-if="scope.row.edit">
                                                    <a href="javascript:void(0);" @click="confirmEdit(scope.row)"><i class="el-icon-check"></i></a>
                                                </li>
                                                <li v-if="scope.row.edit">
                                                    <a href="javascript:void(0);" @click="cancelEdit(scope.row)"><i class="el-icon-close"></i></a>
                                                </li>
                                                <li v-else-if="$store.getters.getConfig('has_permissions').includes('permissions-update')">
                                                    <a href="javascript:void(0);" @click="handleEdit(scope.row)"><i class="icon-edit"></i></a>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Name')" sortable="custom" prop="name" width="350">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.edit">
                                                <el-input v-model="scope.row.name"></el-input>
                                            </template>
                                            <span v-else>{{ scope.row.name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Order Number')" sortable="custom" prop="display_order" width="250">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.edit">
                                                <el-input type="number" v-model="scope.row.display_order"></el-input>
                                            </template>
                                            <span v-else>{{ scope.row.display_order }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Modified at')" sortable="custom" prop="updated_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.updated_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination v-if="permissions.meta.total" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="permissions.meta.total">
                                    <template>
                                        <span class="page-no">{{ $t('Showing out of records',{'0':
                                            permissions.data.length, '1': permissions.meta.total}) }}</span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc"
                },
                dialogFormVisible: false,
                formLabelWidth: "120px",
                permissions: {
                    meta: {},
                    data: []
                },
                currentRow: {},
                dummyRow: {}
            };
        },
        mounted() {
            this.getPermissions();
        },
        methods: {
            getPermissions() {
                request({
                    url: "permissions",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.permissions = response.data;
                    this.permissions.data = this.permissions.data.map(v => {
                        this.$set(v, 'edit', false)
                        return v
                    });
                });
            },
            handleEdit(row) {
                this.cancelEdit(this.dummyRow)
                this.currentRow = Object.assign({}, row);
                this.dummyRow = row;
                row.edit = !row.edit;
            },
            cancelEdit(row) {
                row.edit = false;
                Object.assign(row, this.currentRow);
            },
            confirmEdit(row) {
                row.edit = false
                request({
                    url: "permissions/" + row.id,
                    method: "PATCH",
                    data: row
                }).then(response => {
                    Object.assign(row, response.data.data);
                    this.currentRow = Object.assign({}, row);
                    this.$notify({
                        title: this.$t('Success'),
                        message: response.data.message,
                        type: 'success',
                        offset: 50
                    })
                }).catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.error.message,
                        type: "error",
                        offset: 50
                    });
                });
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.getPermissions(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.getPermissions();
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "id";
                    this.filterData.order = "desc";
                }
                this.getPermissions();
            },
            indexMethod(index) {
                return (
                    index +
                    this.filterData.pageLength * this.filterData.page -
                    this.filterData.pageLength +
                    1
                );
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Permissions/Permissions.vue